import React from 'react';
import "./HomeProjects.css"
import hospital from "../../../images/hospital.png";
import github from "../../../images/github.png";
import live from "../../../images/web.png";
import book from "../../../images/book-store-1.PNG";
import book2 from "../../../images/book-store-2.PNG";
import book3 from "../../../images/book-store-3.PNG";
import hospital2 from "../../../images/jamuna-1.PNG";
import hospital3 from "../../../images/jamuna-3.PNG";
import school from "../../../images/red-mountain.jpg";
import school2 from "../../../images/red-mountain-3.PNG";
import school3 from "../../../images/red-mountain-4.PNG";
import school4 from "../../../images/red-mountain-5.PNG";

const HomeProjects = () => {
    return (
        <div className="mt-5">     
            <div>
                 <h3 className="textColor text-center mt-2"><span className="fs-2 border-bottom border-info">PROJECTS </span></h3>
            </div>       
            <div className="row justify-content-evenly">
            <div className="col-md-2">                
                   <div>         {/* Jamuna Diagonistic center */}
                        <div id="carouselExampleInterval" class="carousel slide shadow-sm mt-4"     data-bs-ride="carousel">
                            <div class="carousel-inner shadow">
                                <div class="carousel-item active" data-bs-interval="10000">
                                <img src={hospital} class="d-block hProject-shot" alt="..."/>
                                </div>
                                <div class="carousel-item" data-bs-interval="2000">
                                <img src={hospital2} class="d-block hProject-shot" alt="..."/>
                                </div>
                                <div class="carousel-item">
                                <img src={hospital3} class="d-block hProject-shot" alt="..."/>
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                   </div>
                   <div className="text-center">
                        <h5 className=" textColor">Jamuna Diagonistic center</h5>
                        <a href="https://github.com/rajonahmed749/jamuna-diagonistic-center" target="_blank" rel="noreferrer"><img className="homeSocialMedia m-1" src={github} alt=""/> </a>
                        <a href="https://jamuna-diagonistic-center.web.app/" target="_blank" rel="noreferrer"><img src={live} className="homeSocialMedia m-1" alt="live"/> </a>
                    </div>
                </div>
                <div className="col-md-2">
                   <div>        {/* Red Mountain kids */}
                        <div id="carouselExampleIntervalH2" class="carousel slide shadow-sm mt-4"     data-bs-ride="carousel">
                            <div class="carousel-inner shadow">
                                <div class="carousel-item active" data-bs-interval="10000">
                                <img src={school} class="d-block hProject-shot" alt="..."/>
                                </div>
                                <div class="carousel-item" data-bs-interval="2000">
                                <img src={school2} class="d-block hProject-shot" alt="..."/>
                                </div>
                                <div class="carousel-item">
                                <img src={school3} class="d-block hProject-shot" alt="..."/>
                                </div>
                                <div class="carousel-item">
                                <img src={school4} class="d-block hProject-shot" alt="..."/>
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIntervalH2" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIntervalH2" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                   </div>
                   <div className="text-center">
                        <h5 className=" textColor">Red Mountain Kids</h5>
                        <a href="https://github.com/rajonahmed749/red-mountain" target="_blank" rel="noreferrer"><img className="homeSocialMedia m-1" src={github} alt=""/> </a>
                        <a href="https://red-mountain-kids.web.app/" target="_blank" rel="noreferrer"><img src={live} className="homeSocialMedia m-1" alt="live"/> </a>
                    </div>
                </div>

                <div className="col-md-2">
                   <div>             {/* The Book Store */}
                        <div id="carouselExampleIntervalH3" class="carousel slide shadow-sm mt-4"     data-bs-ride="carousel">
                            <div class="carousel-inner shadow">
                                <div class="carousel-item active" data-bs-interval="10000">
                                <img src={book} class="d-block hProject-shot" alt="..."/>
                                </div>
                                <div class="carousel-item" data-bs-interval="2000">
                                <img src={book2} class="d-block hProject-shot" alt="..."/>
                                </div>
                                <div class="carousel-item">
                                <img src={book3} class="d-block hProject-shot" alt="..."/>
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIntervalH3" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIntervalH3" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                   </div>
                    <div className="text-center">
                        <h5 className="textColor cShadow">The Book Store</h5>
                        <a href="https://github.com/rajonahmed749/book-store" target="_blank" rel="noreferrer"><img className="homeSocialMedia m-1" src={github} alt=""/> </a>
                        <a href="https://the-book-store-b0c0b.web.app/" target="_blank" rel="noreferrer"><img src={live} className="homeSocialMedia m-1" alt="live"/> </a>
                    </div>
                </div>
            </div>            
        </div>
    );
};

export default HomeProjects;